import { render } from "./DownloadPropertiesButton.vue?vue&type=template&id=3e20d8c0"
import script from "./DownloadPropertiesButton.vue?vue&type=script&lang=js"
export * from "./DownloadPropertiesButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__